import { NavModel } from '@libs/shared/models';

export const APP_STATE_KEY: string = 'app';

export type AppStateMainNavigationStatus = 'pending' | 'loading' | 'error' | 'success';

export interface AppState {
  mainNavigation: AppStateMainNavigation;
}

interface AppStateMainNavigation {
  error: Error | null;
  status: AppStateMainNavigationStatus;
  data: NavModel | undefined;
}

export const initialAppState: AppState = {
  mainNavigation: {
    error: null,
    status: 'pending',
    data: undefined,
  },
};
